import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Tag, Cell } from '@themeable/react-components';
import { Button, HStack, Section, Content, Container, VStack, Space, Divider, Loader, Media, Title1, Title2, Title3, Headline, Body, Subhead, Footnote, Caption1, Caption2, Icon, Input } from '@themeable/react'
import Blockquote from '../../Patterns/Blockquote';
import { AuthorInfo } from './AuthorInfo';
import { DisclaimerAffiliate, DisclaimerMedical } from './Disclaimers';
import { BlogSuggestion } from './Suggestion';
import { TopicJumper } from './TopicJumper';
import { ContentBlock } from '../../Patterns/ContentBlock'


function BlogEntry({ globals, setGlobals }) {
  const [loading, setLoading] = useState(true);
  const { param } = useParams();
  const [pageTitle, setPageTitle] = useState('');
  const [blocks, setBlocks] = useState('');
  const [tags, setTags] = useState('');
  const [medical, setMedical] = useState(false);
  const [affiliate, setAffiliate] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setGlobals((prev) => ({
      ...prev,
      page: '',
      pageColor: '--color-background-elevated'
    }));
  }, [])

  useEffect(() => {
    fetch(`/api/blog/${param}`)
      .then((res) => res.json())
      .then((res) => {
        setPageTitle(res.Name)
        setBlocks(res.Blocks)
        setLoading(false)
        setTags(res.Tags)
        res.Disclaimers.map((disclaimer) => {
          if (disclaimer?.name === 'medical') {
            setMedical(true)
          } else if (disclaimer?.name === 'affiliate') {
            setAffiliate(true)
          }
        })
      })
      .then((res) => {
        setGlobals((prev) => ({
          ...prev,
          blogs: res
        }));
      })
      .catch((error) => { console.error('Error fetching data: ', error); });
  },
    []);




  return (
    <>
      <Section>
        <HStack
          sectionSpacing
          gridExpanded={[2, 3]}
          gridMedium={[1, 1]}
          gridCompact={[1]}
        >
          <HStack>
            <VStack style={{ position: 'relative' }} align='top'>
              <HStack group>
                {tags && (tags.map((tag, index) => (
                  <Tag status='neutral' key={index} text1={tag} />
                )))}
              </HStack>
              <Title1>
                {pageTitle}
              </Title1>

              {medical && (
                <DisclaimerMedical />
              )}
              {affiliate && (
                <DisclaimerAffiliate />
              )}
              <Divider />

              <AuthorInfo />

              <Divider />

              <Container variant='fill'>
                <Subhead color='text-secondary'>Topics:</Subhead>
                {loading ? <>
                  <Button loading small variant='secondary' />
                  <Button loading small variant='secondary' />
                </> : <>
                  <TopicJumper blocks={blocks} />
                </>}

              </Container>
              <Space.NewSection />

              {/* Illustration */}
              {loading ? <></> : <>
                <Space.Grow />
              </>
              }
            </VStack>
            {/* <HStack showOn='medium expanded'> */}
            {/*   <Divider vertical /> */}
            {/* </HStack> */}
          </HStack>

          {/* Right column */}
          <VStack>
            <HStack showOn='compact'>
              <Divider />
              <Space.NewSection />
            </HStack>
            {loading ? <></> : <>
              {blocks?.map((block) => (<>
                <ContentBlock block={block} />
              </>
              ))}
            </>}
          </VStack>
        </HStack>
      </Section>

      <Divider extendLeft extendRight />

      <BlogSuggestion />

    </>
  )
}

export default BlogEntry
